var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "directory-detail clearfix" },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            title: _vm.title,
            buttons: _vm.buttons,
            dotOption: _vm.dotOption,
            fullScreen: true,
          },
        },
        [
          _c(
            "div",
            {
              class: _vm.pointerClass,
              attrs: { slot: "status" },
              on: { click: _vm.openLifecycleFun },
              slot: "status",
            },
            [_c("TheDirStatusHeader")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isEngineer
        ? _c("Lifecycle", {
            ref: "directoryLifecycle",
            attrs: {
              modalId: "directory-modules-lifecycle-modal",
              type: "directory",
              commentAttr: _vm.lifecycleCommentAttrs.comments,
              histories: _vm.histories,
              allowPreformattedComments: true,
              emptyHistoryHint: _vm.emptyHistoryHint,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "directory-detail__info clearfix" },
        [
          _c("div", { staticClass: "effective--date-reject-history" }, [
            _c(
              "div",
              {
                class: [
                  _vm.isFloorDR
                    ? "floor-effective-remove-date"
                    : "effective-remove-date",
                ],
              },
              [
                _vm.showRemoveDate
                  ? _c(
                      "div",
                      { staticClass: "effective-date" },
                      [
                        _c("label", { staticClass: "emphasis required-flag" }, [
                          _vm._v(_vm._s(_vm.$t("directory.removeDate"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "hint" }, [
                          _vm._v(_vm._s(_vm.$t("directory.msg.subjectTo"))),
                        ]),
                        _vm._v(" "),
                        _c("DatePicker", {
                          class: { "error-highlight": _vm.invalidDate },
                          attrs: {
                            id: "directory-effective-date",
                            required: true,
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            disabled: { to: _vm.today },
                            disabledPicker: !_vm.canEditRemoveDate,
                            value: _vm._f("formatDate")(
                              _vm.currentDirectory.removeDate
                            ),
                          },
                          on: {
                            selected: function (val) {
                              return _vm._updateField(["removeDate"], val)
                            },
                            cleared: function ($event) {
                              return _vm._updateField(["removeDate"], null)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showRemoveDate
                  ? _c(
                      "div",
                      { staticClass: "effective-date" },
                      [
                        _c("label", { staticClass: "emphasis required-flag" }, [
                          _vm._v(_vm._s(_vm.$t("directory.effectiveDate"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "hint" }, [
                          _vm._v(_vm._s(_vm.$t("directory.msg.subjectTo"))),
                        ]),
                        _vm._v(" "),
                        _c("DatePicker", {
                          class: { "error-highlight": _vm.invalidDate },
                          attrs: {
                            id: "directory-effective-date",
                            required: true,
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            disabled: { to: _vm.today },
                            disabledPicker: !_vm.editableEffectiveDate,
                            value: _vm._f("formatDate")(
                              _vm.currentDirectory.effectiveDate
                            ),
                          },
                          on: {
                            selected: function (val) {
                              return _vm._updateField(["effectiveDate"], val)
                            },
                            cleared: function ($event) {
                              return _vm._updateField(["effectiveDate"], null)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isFloorDR
                  ? _c(
                      "div",
                      { staticClass: "floor" },
                      [
                        _c("label", { staticClass: "emphasis required-flag" }, [
                          _vm._v(_vm._s(_vm.$t("directory.label.floor"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "hint" }, [
                          _vm._v(_vm._s(_vm.$t("directory.msg.selectFloor"))),
                        ]),
                        _vm._v(" "),
                        _c("HKLSelect", {
                          class: { "error-highlight": _vm.invalidFloor },
                          attrs: {
                            options: _vm.floorOptions,
                            placeholder: "",
                            showSearch: true,
                            value: _vm.currentDirectory.floor,
                            required: _vm.isFloorDR,
                            disabled: !_vm.editableEffectiveDate,
                          },
                          on: {
                            change: function (val) {
                              return _vm._updateField(["floor"], val)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "guideline",
                class: ["guideline", _vm.isFloorDR ? "floor-guideline" : ""],
              },
              [
                _c("div", { staticClass: "emphasis guideline-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "termsAndConditions." +
                          _vm.regionName +
                          ".directoryGuideLine.title"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ol",
                  _vm._l(
                    _vm.$t(
                      "termsAndConditions." +
                        _vm.regionName +
                        ".directoryGuideLine.content"
                    ),
                    function (item, key) {
                      return _c("li", { key: key }, [_vm._v(_vm._s(item))])
                    }
                  ),
                  0
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.latestRejectedHistory
            ? _c("div", { staticClass: "reject-history" }, [
                _c("label", { staticClass: "emphasis" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("directory.label.commentsFromOn", [
                        _vm.latestRejectedHistory.who,
                        _vm.latestRejectedHistory.when,
                      ])
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reject-history__item" }, [
                  _c("div", { staticClass: "reject-comment" }, [
                    _c("pre", [
                      _vm._v(_vm._s(_vm.latestRejectedHistory.comment)),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          [
            _vm.companies.length
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "small-6 large-6 columns detail" },
                    [
                      _vm._l(_vm.companies, function (company, index) {
                        return [
                          _c("Company", {
                            key: company.id,
                            attrs: {
                              id: company.id,
                              index: index,
                              company: company,
                              type: _vm.currentDirectory.type,
                            },
                            on: {
                              "update:company": function ($event) {
                                company = $event
                              },
                              "reset:validation": _vm.resetValidation,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "small-6 large-6 preview" },
                    [
                      _c("img", { attrs: { src: _vm.directoryImg } }),
                      _vm._v(" "),
                      _c("UploadDocs"),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "confirmSubmit",
        attrs: {
          modalId: "confirm-" + _vm.currentDirectory.id,
          confirmTitle: _vm.confirmTitle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }